export * from './auction-chat2.component';
export * from './auction-chat2.module';
